class Publish {
	constructor(streamId, app, name, stream, wsUrl, callback) {
		this.stream_id = streamId
		this.app = app
		this.name = name
		this.stream = stream
		this.peerConnectionConfig = {
			iceServers: []
		}
		this.RTCPeerConnection = null
		this.sdpData = null
		this.iceCandidates = null
		this.video = null
		this.videos = null
		this.description = null
		this.videoBitrate = 4000
		this.videoFrameRate = 30
		this.setRemoteDescription = this.setRemoteDescription.bind(this)
		this.gotDescription = this.gotDescription.bind(this)
		this.addIceCandidate = this.addIceCandidate.bind(this)
		this.push_return = this.pushReturn.bind(this)
		this.ws_url = wsUrl
		this.wsConnection_publish = null
		this.alive = null
		this.heartbeat_play = this.heartbeatPlay.bind(this)
		this.wsConnect_publish = this.wsConnectPublish.bind(this)
		/* 推流状态  0 未推流  1 成功  2 失败 3 停止 */
		this.push_state = 0
		this.callback = callback
		this.videoFrameRate = '30'
		this.videoChoice = '42e01f'
		this.audioChoice = 'pcma'
		this.SDPOutput = null
		this.videoIndex = -1
		this.audioIndex = -1
	}
	set(sdpData, iceCandidates) {
		this.sdpData = sdpData
		this.iceCandidates = iceCandidates
	}
	setVideoBitrate(videoBitrate) {
		this.videoBitrate = videoBitrate
	}
	setVideoFrameRate(videoFrameRate) {
		this.videoFrameRate = videoFrameRate
	}
	createOffer() {
		// 创建通道
		this.RTCPeerConnection = new RTCPeerConnection(this.peerConnectionConfig)
		this.RTCPeerConnection.onicecandidate = this.gotIceCandidate
		this.RTCPeerConnection.addStream(this.stream)
		this.RTCPeerConnection.createOffer(this.gotDescription, this.errorHandler)
	}
	Callbacks(type) {
		console.log('Callbacks:::', type)
		this.callback(type)
	}
	setRemoteDescription() {
		this.RTCPeerConnection.setRemoteDescription(new RTCSessionDescription(this.sdpData), function () {

		}, this.errorHandler)
	}
	addIceCandidate() {
		if (!this.iceCandidates) {
			for (var index in this.iceCandidates) {
				this.RTCPeerConnection.addIceCandidate(new RTCIceCandidate(this.iceCandidates[index]))
			}
		}
	}
	gotDescription(description) {
		// console.log(description.sdp)
		// var enhanceData = null
		// if (this.videoBitrate !== undefined) {
		// 	enhanceData.videoBitrate = Number(this.videoBitrate)
		// }
		// if (this.videoFrameRate !== undefined) {
		// 	enhanceData.videoFrameRate = Number(this.videoFrameRate)
		// }
		// description.sdp = this.enhanceSDP(description.sdp, enhanceData)
		this.description = description
		this.RTCPeerConnection.setLocalDescription(
			this.description,
			this.push_return,
			function () {
				console.log('set description error')
			},
		)
	}
	pushReturn() {
		this.wsConnection_publish.send(
			'{"cmd":"publish","streamInfo":{"applicationName":"' + this.app +
			'","sessionId":"[empty]","streamName":"' + this.stream_id + '"}, "app":"' +
			this.app +
			'", "stream":"' +
			this.stream_id + '", "sdp":' +
			JSON.stringify(this.description) +
			'}',
		)
	}
	gotIceCandidate(event) {
		if (event.candidate != null) {

		}
	}
	errorHandler(error) {
		console.log(error)
	}

	wsConnectPublish() {
		this.wsConnection_publish = new WebSocket(this.ws_url)
		this.wsConnection_publish.binaryType = 'arraybuffer'
		var curObj = this
		// 链接webrtc
		this.wsConnection_publish.onopen = function () {
			this.alive = setTimeout(function () {
				curObj.heartbeatPlay()
			}, 1000 * 3)
			curObj.createOffer()
		}
		// 返回消息
		this.wsConnection_publish.onmessage = function (evt) {
			console.log('publishonmessage', evt.data)
			var msgJSON = JSON.parse(evt.data)
			var msgStatus = Number(msgJSON['status'])
			// 在这里判断 没连上404
			if (msgStatus == 404) {

			}
			if (msgJSON['cmd'] == 'publish') {
				if (msgStatus != 200) {
					// 推流不成功提示
					// alert("推流不成功")
				} else {
					// 推流成功执行以下操作
					var sdpData = msgJSON['sdp']
					var iceCandidates = msgJSON['iceCandidates']
					curObj.set(sdpData, iceCandidates)
					curObj.setRemoteDescription()
					if (iceCandidates !== undefined) {
						curObj.addIceCandidate()
					}
				}
			}
			if (msgJSON['cmd'] == 'notify') {
				if (msgJSON['event'] == 'pushok') {
					console.log('CallbacksCallbacksCallbacksCallbacks')
					curObj.Callbacks(1)
					curObj.push_state = 1
				} else if (msgJSON['event'] == 'pushclosed') {
					curObj.Callbacks(2)
					curObj.push_state = 2
				}
			}
			if (msgJSON['cmd'] == 'alive') {
				this.alive = setTimeout(function () {
					curObj.heartbeatPlay()
				}, 1000 * 7)
			}
		}

		this.wsConnection_publish.onerror = function (evt) {
			// console.log("wsConnection_publish.onerror: "+JSON.stringify(evt))
			// stopPublisher()
		}

		this.wsConnection_publish.onclose = function () {
			curObj.wsConnection_publish = null
			if (curObj.push_state != 3) {
				setTimeout(function () {
					curObj.wsConnectPublish()
				}, 5000)
			}
		}
	}
	heartbeatPlay() {
		clearTimeout(this.alive)
		this.wsConnection_publish.send('{"cmd":"alive"}')
	}

	// sdp修改
	enhanceSDP(sdpStr, enhanceData) {
		var sdpLines = sdpStr.split(/\r\n/)
		var sdpSection = 'header'
		var hitMID = false
		var sdpStrRet = ''

		// console.log("Original SDP: "+sdpStr)
		// Firefox provides a reasonable SDP, Chrome is just odd
		// so we have to doing a little mundging to make it all work
		if (!sdpStr.includes('THIS_IS_SDPARTA') || this.videoChoice.includes('VP9')) {
			for (var sdpIndex in sdpLines) {
				var sdpLine = sdpLines[sdpIndex]

				if (sdpLine.length <= 0) {
					continue
				}

				// var doneCheck = checkLine(sdpLine)
				// if ( !doneCheck )
				//   continue

				sdpStrRet += sdpLine
				sdpStrRet += '\r\n'
			}
			sdpStrRet = this.addAudio(sdpStrRet, this.deliverCheckLine(this.audioChoice, 'audio'))
			sdpStrRet = this.addVideo(sdpStrRet, this.deliverCheckLine(this.videoChoice, 'video'))
			sdpStr = sdpStrRet
			sdpLines = sdpStr.split(/\r\n/)
			sdpStrRet = ''
		}

		for (let sdpIndex in sdpLines) {
			let sdpLine = sdpLines[sdpIndex]

			if (sdpLine.length <= 0) {
				continue
			}

			if (sdpLine.indexOf('m=audio') == 0 && this.audioIndex != -1) {
				let audioMLines = sdpLine.split(' ')
				sdpStrRet += audioMLines[0] + ' ' + audioMLines[1] + ' ' + audioMLines[2] + ' ' + this.audioIndex + '\r\n'
				continue
			}

			if (sdpLine.indexOf('m=video') == 0 && this.videoIndex != -1) {
				let audioMLines = sdpLine.split(' ')
				sdpStrRet += audioMLines[0] + ' ' + audioMLines[1] + ' ' + audioMLines[2] + ' ' + this.videoIndex + '\r\n'
				// console.log(videoIndex)
				// console.log(sdpStrRet)
				continue
			}

			sdpStrRet += sdpLine

			if (sdpLine.indexOf('m=audio') === 0) {
				sdpSection = 'audio'
				hitMID = false
			} else if (sdpLine.indexOf('m=video') === 0) {
				sdpSection = 'video'
				hitMID = false
			} else if (sdpLine.indexOf('a=rtpmap') == 0) {
				sdpSection = 'bandwidth'
				hitMID = false
			}

			if (sdpLine.indexOf('a=mid:') === 0 || sdpLine.indexOf('a=rtpmap') == 0) {
				if (!hitMID) {
					if ('audio'.localeCompare(sdpSection) == 0) {
						if (enhanceData.audioBitrate !== undefined) {
							sdpStrRet += '\r\nb=CT:' + (enhanceData.audioBitrate)
							sdpStrRet += '\r\nb=AS:' + (enhanceData.audioBitrate)
						}
						hitMID = true
					} else if ('video'.localeCompare(sdpSection) == 0) {
						if (enhanceData.videoBitrate !== undefined) {
							sdpStrRet += '\r\nb=CT:' + (enhanceData.videoBitrate)
							sdpStrRet += '\r\nb=AS:' + (enhanceData.videoBitrate)
							if (enhanceData.videoFrameRate !== undefined) {
								sdpStrRet += '\r\na=framerate:' + enhanceData.videoFrameRate
							}
						}
						hitMID = true
					} else if ('bandwidth'.localeCompare(sdpSection) == 0) {
						var rtpmapID
						rtpmapID = this.getrtpMapID(sdpLine)
						if (rtpmapID !== null) {
							var match = rtpmapID[2].toLowerCase()
							if (('vp9'.localeCompare(match) == 0) || ('vp8'.localeCompare(match) == 0) || ('h264'
									.localeCompare(match) == 0) ||
								('red'.localeCompare(match) == 0) || ('ulpfec'.localeCompare(match) == 0) || ('rtx'
									.localeCompare(match) == 0)) {
								if (enhanceData.videoBitrate !== undefined) {
									sdpStrRet += '\r\na=fmtp:' + rtpmapID[1] + ' x-google-min-bitrate=' + (
										enhanceData.videoBitrate) + 'x-google-max-bitrate=' + (enhanceData
										.videoBitrate)
								}
							}

							if (('opus'.localeCompare(match) == 0) || ('isac'.localeCompare(match) == 0) || ('g722'
									.localeCompare(match) == 0) || ('pcmu'.localeCompare(match) == 0) ||
								('pcma'.localeCompare(match) == 0) || ('cn'.localeCompare(match) == 0)) {
								if (enhanceData.audioBitrate !== undefined) {
									sdpStrRet += '\r\na=fmtp:' + rtpmapID[1] + ' x-google-min-bitrate=' + (
										enhanceData.audioBitrate) + 'x-google-max-bitrate=' + (enhanceData
										.audioBitrate)
								}
							}
						}
					}
				}
			}
			sdpStrRet += '\r\n'
		}
		// console.log("Resuling SDP: " + sdpStrRet)
		return sdpStrRet
	}

	addVideo(sdpStr, videoLine) {
		var sdpLines = sdpStr.split(/\r\n/)
		var sdpSection = 'header' // eslint-disable-line no-unused-vars 
		var hitMID = false // eslint-disable-line no-unused-vars 
		var sdpStrRet = ''
		var done = false

		var rtcpSize = false
		var rtcpMux = false // eslint-disable-line no-unused-vars 

		for (var sdpIndex in sdpLines) {
			var sdpLine = sdpLines[sdpIndex]

			if (sdpLine.length <= 0) {
				continue
			}

			if (sdpLine.includes('a=rtcp-rsize')) {
				rtcpSize = true
			}

			if (sdpLine.includes('a=rtcp-mux')) {
				rtcpMux = true
			}
		}

		for (let sdpIndex in sdpLines) {
			let sdpLine = sdpLines[sdpIndex]

			sdpStrRet += sdpLine
			sdpStrRet += '\r\n'

			if (('a=rtcp-rsize'.localeCompare(sdpLine) == 0) && done == false && rtcpSize == true) {
				sdpStrRet += videoLine
				done = true
			}

			if ('a=rtcp-mux'.localeCompare(sdpLine) == 0 && done == true && rtcpSize == false) {
				sdpStrRet += videoLine
				done = true
			}

			if ('a=rtcp-mux'.localeCompare(sdpLine) == 0 && done == false && rtcpSize == false) {
				done = true
			}
		}
		return sdpStrRet
	}

	getrtpMapID(line) {
		var findid = new RegExp('a=rtpmap:(\\d+) (\\w+)/(\\d+)')
		var found = line.match(findid)
		return (found && found.length >= 3) ? found : null
	}
	addAudio(sdpStr, audioLine) {
		var sdpLines = sdpStr.split(/\r\n/)
		var sdpSection = 'header' // eslint-disable-line no-unused-vars 
		var hitMID = false // eslint-disable-line no-unused-vars 
		var sdpStrRet = ''
		var done = false

		for (var sdpIndex in sdpLines) {
			var sdpLine = sdpLines[sdpIndex]

			if (sdpLine.length <= 0) {
				continue
			}
			sdpStrRet += sdpLine
			sdpStrRet += '\r\n'

			if ('a=rtcp-mux'.localeCompare(sdpLine) == 0 && done == false) {
				sdpStrRet += audioLine
				done = true
			}
		}
		return sdpStrRet
	}

	deliverCheckLine(profile, type) {
		var outputString = ''
		for (var line in this.SDPOutput) {
			var lineInUse = this.SDPOutput[line]
			outputString += line
			if (lineInUse.includes(profile)) {
				if (profile.includes('VP9') || profile.includes('VP8')) {
					var output = ''
					var outputs = lineInUse.split(/\r\n/)
					for (var position in outputs) {
						var transport = outputs[position]
						if (transport.indexOf('transport-cc') !== -1 || transport.indexOf('goog-remb') !== -1 ||
							transport.indexOf('nack') !== -1) {
							continue
						}
						output += transport
						output += '\r\n'
					}
					if (type.includes('audio')) {
						this.audioIndex = line
					}
					if (type.includes('video')) {
						this.videoIndex = line
					}
					return output
				}
				if (type.includes('audio')) {
					this.audioIndex = line
				}
				if (type.includes('video')) {
					this.videoIndex = line
				}
				return lineInUse
			}
		}
		return outputString
	}

	stopPush() {
		this.push_state = 3
		this.RTCPeerConnection = null
		this.wsConnection_publish = null
	}
}
export default Publish